module.exports = __webpack_public_path__ + "media/audio6.cd38e33c.mp3";